import React from 'react'
import { Modal } from 'react-bootstrap'
import { NOTIFICATION_STATUSES } from './constants'
import clsx from 'clsx'

export default function FCMPreview({ notification, isShow, onHide }) {
  if (!notification) return null

  const info = JSON.parse(notification?.payload)

  return (
    <Modal show={isShow} onHide={onHide} size="lg">
      <Modal.Header>
        <Modal.Title>ตัวอย่าง</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notification && (
          <div className="d-flex flex-column w-100 align-items-center">
            <div
              className={clsx(
                'd-flex flex-column border border-success rounded p-4',
                [NOTIFICATION_STATUSES.PUBLISH, NOTIFICATION_STATUSES.IN_PROGRESS].includes(notification.status)
                  ? 'border-success'
                  : 'border-secondary',
              )}
              style={{ minWidth: '360px', width: '360px' }}
            >
              <div className="d-flex justify-content-center mt-2">
                <img src="./img/logo_Bird.png" alt="logo" style={{ width: '60px' }} />
              </div>
              <div className="d-flex justify-content-center mt-2">
                <h3>{info.messages.title}</h3>
              </div>
              <div className="d-flex mt-2">{info.messages.body}</div>
              {info.imageUrl && (
                <div className="d-flex justify-content-center mt-2">
                  <img src={info.imageUrl} alt={info.messages.title} style={{ width: '100%', maxWidth: '360px' }} />
                </div>
              )}
              <div className="d-flex justify-content-center mt-2">
                {notification.link && (
                  <a href={notification.link} alt={`รูป ${info.messages.title}`}>
                    <strong>{notification.link}</strong>
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}
